export default "__VITE_ASSET__84e4588e__"